export default __webpack_public_path__ + "static/media/naval.f1b224b6.svg";